<template>
  <div ref="wrapper" style="height: 100%">
    <slot v-if="!initLoading"></slot>
    <div
      style="height: 100px; width: 100%"
      v-loading="true"
      class="scoll-loading"
      v-if="isLoading || initLoading"
    ></div>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
export default {
  props: {
    page: Number,
    getList: Function,
    lastPage: Number,
    space: {
      type: Number,
      default: 100,
    },
    initLoading: {
      type: Boolean,
      default: false,
    },
    window: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const wrapper = ref(null);
    const isLoading = ref(false);

    const noMore = computed(() => {
      return isLoading.value || props.lastPage === props.page;
    });

    /**
     * scrollTop 元素在Ｙ軸滾動條上的距離
     * clientHeight 元素的可視高度
     * scrollHeight 為內容可視高度加上滾動的距離
     */
    const scroll = async () => {
      if (noMore.value || props.initLoading) return;
      isLoading.value = true;

      let scrollTop;
      let clientHeight;
      let scrollHeight;

      if (props.window) {
        scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        clientHeight = document.documentElement.clientHeight;
        scrollHeight = document.documentElement.scrollHeight;
      } else {
        scrollTop = wrapper.value.parentNode.scrollTop;
        clientHeight = wrapper.value.parentNode.clientHeight;
        scrollHeight = wrapper.value.parentNode.scrollHeight;
      }

      if (clientHeight + scrollTop + 100 >= scrollHeight) {
        await props.getList(props.page + 1);
      }
      isLoading.value = false;
    };

    // const windowScroll = async () => {
    //   const scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   const clientHeight = document.documentElement.clientHeight;
    //   const scrollHeight = document.documentElement.scrollHeight;
    //   if (clientHeight + scrollTop + 100 >= scrollHeight) {
    //     console.log("到達底部了");
    //   }
    // };

    onMounted(() => {
      if (props.window) {
        return window.addEventListener("scroll", scroll);
      }
      wrapper.value.parentNode.addEventListener("scroll", scroll);
    });

    onBeforeUnmount(() => {
      if (props.window) {
        return window.removeEventListener("scroll", scroll);
      }
      wrapper.value.parentNode.removeEventListener("scroll", scroll);
    });

    return {
      wrapper,
      isLoading,
    };
  },
};
</script>
